<template>
    <div>
   <div class="md:flex p-6 btn-transparent min-h-screen flex justify-center items-center" style="background-color: #2D2E2C; ">
     <div class="w-full max-w-md">
       <logo/>
       <form class="mt-6 bg-transparent rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
         <div class="px-10 py-1">
            <h3 style="color: white;"><b>{{ name }}, Gracias por registrarte con nosotros</b></h3>
            <br>
            <p style="color: white;">Revisa tu email para confirmar que tu correo sea valido, sino te llego vuelve a enviar el email en el enlace de abajo.</p>
           <br>
            <text-input v-model="form.email" :error="form.errors.email" style="color: white;" class="pr-6 pb-4 w-full lg:w-6/6 font-bold mt-2" type="email" autofocus autocapitalize="off" label="Email" placeholder="mito@gmail.com" required disabled/>
           <div class="flex justify-center items-center">
           <br>
           <loading-button :loading="form.processing" class="px-10 py-2 btn-indigoOrange ml-auto" type="submit"  style="align-content: end;">Volver a enviar email</loading-button>
           <br>   <br> <br>   <br>
         </div>
         </div>
       </form>
     </div>
   </div>
  </div>
 </template>
 
 <script>
 import Logo from '@/Shared/Logo'
 import TextInput from '@/Shared/TextInput'
 import LoadingButton from '@/Shared/LoadingButtonOrange'

 
 export default {
   metaInfo: { title: 'Verify Email' },
   components: {
     LoadingButton,
     Logo,
     TextInput,
   },
   props: {
    name: Object,
    email: Object,
  },
   data() {
     return {
       valida: false,
       mensagge: '',
       form: this.$inertia.form({
         nombres: this.name,
         email: this.email, 
       }),
     }
   },
   methods: {
     login() {
       this.form.post(this.route('sendemail'))
     },
   
   },
 }
 </script>
 